import React from 'react';
import { useApp } from '../context/AppContext';

const FiltersPanel = () => {
  const { filters, lookupData, handleFilterChange } = useApp();

  return (
    <div className="max-w-7xl mx-auto px-4 -mt-24 mb-6 relative z-10">
      <div className="bg-white rounded-2xl shadow-xl p-6 border">
        <div className="flex justify-between mb-6">
          <h3 className="text-lg font-semibold">Filter Results</h3>
          <button onClick={() => handleFilterChange({ providerTypes: [], services: [], insurance: [], priceMax: 200, rating: 0, availability: [] })} className="text-teal-600 text-sm">Reset All</button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Provider Type</label>
            <div className="space-y-2 max-h-40 overflow-y-auto">
              {lookupData.providerTypes.map(t => (
                <label key={t.id} className="flex items-center gap-2 text-sm cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={filters.providerTypes.includes(t.id)} 
                    onChange={e => {
                      const newTypes = e.target.checked 
                        ? [...filters.providerTypes, t.id] 
                        : filters.providerTypes.filter(x => x !== t.id);
                      handleFilterChange({ ...filters, providerTypes: newTypes });
                    }} 
                    className="w-4 h-4 text-teal-600 rounded" 
                  />
                  {t.name}
                </label>
              ))}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Services</label>
            <div className="space-y-2 max-h-40 overflow-y-auto">
              {lookupData.services.map(s => (
                <label key={s.id} className="flex items-center gap-2 text-sm cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={filters.services.includes(s.id)} 
                    onChange={e => {
                      const newServices = e.target.checked 
                        ? [...filters.services, s.id] 
                        : filters.services.filter(x => x !== s.id);
                      handleFilterChange({ ...filters, services: newServices });
                    }} 
                    className="w-4 h-4 text-teal-600 rounded" 
                  />
                  {s.name}
                </label>
              ))}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Insurance</label>
            <div className="space-y-2 max-h-40 overflow-y-auto">
              {lookupData.insuranceProviders.map(i => (
                <label key={i.id} className="flex items-center gap-2 text-sm cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={filters.insurance.includes(i.id)} 
                    onChange={e => {
                      const newInsurance = e.target.checked 
                        ? [...filters.insurance, i.id] 
                        : filters.insurance.filter(x => x !== i.id);
                      handleFilterChange({ ...filters, insurance: newInsurance });
                    }} 
                    className="w-4 h-4 text-teal-600 rounded" 
                  />
                  {i.name}
                </label>
              ))}
            </div>
          </div>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Max Price: ${filters.priceMax}/hr</label>
              <input 
                type="range" 
                min="20" 
                max="200" 
                value={filters.priceMax} 
                onChange={e => handleFilterChange({ ...filters, priceMax: +e.target.value })} 
                className="w-full accent-teal-600" 
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Min Rating: {filters.rating}+</label>
              <input 
                type="range" 
                min="0" 
                max="5" 
                step="0.5" 
                value={filters.rating} 
                onChange={e => handleFilterChange({ ...filters, rating: +e.target.value })} 
                className="w-full accent-teal-600" 
              />
            </div>
          </div>
        </div>
        <div className="mt-6 pt-6 border-t">
          <label className="block text-sm font-medium text-slate-700 mb-3">Availability</label>
          <div className="flex flex-wrap gap-2">
            {['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].map((d,i) => (
              <button 
                key={i} 
                onClick={() => {
                  const newAvailability = filters.availability.includes(i) 
                    ? filters.availability.filter(x => x !== i) 
                    : [...filters.availability, i];
                  handleFilterChange({ ...filters, availability: newAvailability });
                }} 
                className={`px-4 py-2 rounded-lg text-sm font-medium ${filters.availability.includes(i) ? 'bg-teal-600 text-white' : 'bg-slate-100 text-slate-600'}`}
              >
                {d}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FiltersPanel;
